<wr-new-data-table headerText="Rundgänge"
                   localStorageIdentifier="external-inspection-overview"
                   [loadItemsFunction]="loadInspections"
                   [getCountFunction]="getCount"
                   (lineClick)="navigateToInspection($event)"
                   [form]="form"
                   [isAdmin]="false">
  <ng-template dataTableFilter>
    @if (form) {
      <form [formGroup]="form" class="filter-form">
        <div class="filter-control-group">
          <label class="label" for="textFilter">Textfilter</label>
          <input type="text" nbInput id="textFilter" formControlName="fullTextSearch" placeholder="Filter Text...">
        </div>
        <div class="filter-control-group">
          <label class="label" for="datePicker">Zeitraum</label>
          <wr-date-range-picker id="datePicker" formControlName="selectedRange"
                                [showTodayButton]="true"></wr-date-range-picker>
        </div>
        <div class="filter-control-group">
          <label class="label" for="continuationNumber">Folgenummer</label>
          <input type="text" nbInput id="continuationNumber" min="0" formControlName="continuationNumber"
                 placeholder="Folgenummer...">
        </div>
        <div class="filter-control-group">
          <label class="label" for="building">Gebäude</label>
          <wr-building-select id="building"
                              formControlName="building">
          </wr-building-select>
        </div>
        <div class="filter-control-group">
          <label class="label" for="regionSelect">Bereich</label>
          <wr-region-select id="regionSelect" formControlName="region" [fixedTenantId]="tenantId()"></wr-region-select>
        </div>
        <div class="filter-control-group">
          <label class="label" for="teamSelect">Team</label>
          <wr-team-select id="teamSelect" formControlName="team" [fixedTenantId]="tenantId()" [regionId$]="form.get('regionId')?.valueChanges"></wr-team-select>
        </div>
        <div class="filter-control-group">
          <label class="label" for="buildingCondition">Zustand</label>
          <wr-condition-select id="buildingCondition" formControlName="condition">
          </wr-condition-select>
        </div>
      </form>
    }
  </ng-template>

  <ng-template
    dataColumn
    let-inspection
    key="continuationNumber"
    display="FolgeNr">
    @if (inspection.continuationNumber) {
      <div>
        {{ inspection.continuationNumber }}
      </div>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-inspection
    key="status"
    display="Status">
    @if (inspection.status) {
      <div>
        <wr-status-text [status]="inspection.status"></wr-status-text>
      </div>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-inspection
    key="fromTimestamp"
    exportKey="fromTimestamp"
    display="Datum">
    @if (inspection.fromTimestamp) {
      <div>
        {{ inspection.fromTimestamp | date: 'dd.MM.yyyy' }}
      </div>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-inspection
    key="address"
    exportKey="building.baseData.sectionText"
    display="Gebäude">
    <wr-building-badge [building]="inspection.building"></wr-building-badge>
  </ng-template>
  <ng-template
    dataColumn
    let-inspection
    key="technician"
    exportKey="technician.fullName"
    display="Techniker*in">
    <wr-user-badge [user]="inspection.technician" [disableLink]="true"></wr-user-badge>
  </ng-template>
  <ng-template
    dataColumn
    let-inspection
    key="clerk"
    exportKey="clerk.fullName"
    display="Sachbearbeiter*in">
    <wr-user-badge [user]="inspection.clerk" [disableLink]="true"></wr-user-badge>
  </ng-template>
  <ng-template
    dataColumn
    let-inspection
    key="condition"
    exportKey="condition.conditionValue"
    [exportDecimals]="2"
    display="Zustand"
    [sortable]="false">
    @if (inspection.condition.conditionValue) {
      <div>
        <wr-building-condition
          [condition]="inspection.condition.conditionValue"></wr-building-condition>
      </div>
    }
  </ng-template>
</wr-new-data-table>
